module.exports = __webpack_public_path__ + "img/cupra_05.0e71bdae.jpeg";